// extracted by mini-css-extract-plugin
export var warningWrapper = "l_pq d_s d_bB d_bL d_bF d_k d_X d_bP";
export var btn = "l_mZ d_cz d_bY d_dx d_dn";